import React, { useRef, useEffect, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Paper from "@mui/material/Paper";
import { createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import LinearProgress from "@mui/material/LinearProgress";

import DateFnsUtils from "@date-io/date-fns";
import axios from "axios";
import { format } from "date-fns";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import InputAdornment from "@mui/material/InputAdornment";
import EventIcon from "@mui/icons-material/Event";

const drawerWidth = 300;

const materialTheme = createTheme({
  // set default for now
});

const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  appBar: {
    position: "fixed",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  fullWidth: {
    width: "100%",
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function InvoiceInformationReview(props) {
  const classes = useStyles();
  const [isSuccessSaving, setIsSuccessSaving] = useState(false);
  const [isSavingTransaction, setIsSavingTransaction] = useState(false);
  const [showMessageDialog, setShowMessageDialog] = useState(false);
  const [messageDialogMessage, setMessageDialogMessage] = useState("");
  const [documentNumber, setDocumentNumber] = useState("");
  const [receivedDate, setReceivedDate] = React.useState(new Date());
  const [receivedDateCalenderOpen, setReceivedDateCalenderOpen] = useState(false);

  const receivedDateHandleDateChange = (date) => {
    setReceivedDate(date);
  };

  const documentNumberOnTextChanged = (event) => {
    setDocumentNumber(event.target.value);
  };

  function computeTotalAmoun() {
    const totalAmount = props.reviewedSalesOrderItems.reduce((totalPartialSum, product) => {
      const totalOrderValue = Number(
        product.uoms.reduce((partialSum, unit) => {
          if (unit.to_receive_quantity === null) {
            return partialSum + 0;
          }

          if (unit.to_receive_quantity.length <= 0) {
            return partialSum + 0;
          } else {
            return partialSum + parseFloat(unit.to_receive_quantity) * unit.price_with_tax;
          }
        }, 0.0)
      );
      return totalPartialSum + totalOrderValue;
    }, 0.0);

    return Number(totalAmount.toFixed(2)).toLocaleString("en-US", { maximumFractionDigits: 2 });
  }

  function totalOrderItemCount() {
    console.log("unit", props.reviewedSalesOrderItems);
    const totalAmount = props.reviewedSalesOrderItems.reduce((totalPartialSum, product) => {
      const totalOrderValue = Number(
        product.uoms.reduce((partialSum, unit) => {
          if (unit.to_receive_quantity === null) {
            return partialSum + 0;
          }

          if (unit.to_receive_quantity.length <= 0) {
            return partialSum + 0;
          } else {
            return partialSum + unit.to_receive_quantity;
          }
        }, 0)
      );
      return totalPartialSum + totalOrderValue;
    }, 0);

    return Number(totalAmount.toFixed(2)).toLocaleString("en-US", { maximumFractionDigits: 0 });
  }

  function saveReceivedSalesOrderProducs() {
    setIsSavingTransaction(true);

    const newSelectedSalesOrderData = { ...props.selectedSalesOrder };
    delete newSelectedSalesOrderData.sales_order_items;

    const salesOrderInformation = objectToFormData(newSelectedSalesOrderData);
    salesOrderInformation.append("document_number", documentNumber);
    salesOrderInformation.append("received_date", format(receivedDate, "yyyy-MM-dd 00:00:00"));
    salesOrderInformation.append(
      "accepted_sales_order_items",
      JSON.stringify(props.reviewedSalesOrderItems)
    );

    const options = {
      method: "POST",
      url: "/TransactiSellerReceivedSaleOrderInformations/saveReceivedSaleOrderItems.json",
      data: salesOrderInformation,
    };
    axios(options)
      .then((res) => {
        setIsSavingTransaction(false);
        console.log(res);
        const isSuccess = res.data.response.is_success;
        const message = res.data.response.message;

        setMessageDialogMessage(message);

        if (!isSuccess) {
          setIsSuccessSaving(false);
          setShowMessageDialog(true);
          return;
        }

        setIsSuccessSaving(true);
        setShowMessageDialog(true);
      })
      .catch((error) => {
        setIsSavingTransaction(false);
        console.log(error);
      });
  }

  const objectToFormData = (object) =>
    Object.keys(object).reduce((formData, key) => {
      formData.append(key, object[key]);

      return formData;
    }, new FormData());

  function progressDialog() {
    return (
      <Dialog fullWidth={true} maxWidth={"lg"} open={isSavingTransaction} onClose={() => {}}>
        <DialogContent>
          <DialogContentText>Saving received invoice... Please wait...</DialogContentText>
          <LinearProgress color="secondary" />
        </DialogContent>
      </Dialog>
    );
  }
  function messageDialog() {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={showMessageDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {messageDialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowMessageDialog(false);
              if (isSuccessSaving) {
                props.salesOrderSuccessfullyReceived(props.selectedSalesOrder);
              }
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  return (
    <div>
      <Dialog
        fullScreen
        open={props.openInvoiceInformationReviewDialog}
        onClose={() => {
          props.setOpenInvoiceInformationReviewDialog(false);
        }}
        TransitionComponent={Transition}
      >
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={() => {
                props.setOpenInvoiceInformationReviewDialog(false);
              }}
              aria-label="close"
              size="large"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="subtitle1" className={classes.title}>
              Invoice information review
            </Typography>
          </Toolbar>
        </AppBar>
        <div className={classes.appBarSpacer}></div>
        <div style={{ padding: ".5rem" }}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              Document Number*
            </Grid>
            <Grid item xs={12}>
              <StyledEngineProvider injectFirst>
                <ThemeProvider theme={materialTheme}>
                  <TextField
                    className={classes.fullWidth}
                    id="contact-name"
                    rows={4}
                    variant="outlined"
                    onChange={documentNumberOnTextChanged}
                  />
                </ThemeProvider>
              </StyledEngineProvider>
            </Grid>

            <Grid item xs={12}>
              Product Received Date*
            </Grid>
            <Grid item xs={12}>
              <StyledEngineProvider injectFirst>
                <ThemeProvider theme={materialTheme}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <MobileDatePicker
                      inputFormat="MMMM d, yyyy"
                      onClick={() => setReceivedDateCalenderOpen(true)}
                      value={receivedDate}
                      open={receivedDateCalenderOpen}
                      onOpen={() => setReceivedDateCalenderOpen(true)}
                      onClose={() => setReceivedDateCalenderOpen(false)}
                      onChange={receivedDateHandleDateChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          className={classes.fullWidth}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  edge="end"
                                  onClick={() => {
                                    setReceivedDateCalenderOpen(true);
                                  }}
                                >
                                  <EventIcon />
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </ThemeProvider>
              </StyledEngineProvider>
            </Grid>

            <Grid item xs={12}>
              Seller Name
            </Grid>
            <Grid item xs={12} style={{ paddingLeft: "1rem" }}>
              <Typography variant="subtitle1" component="h2">
                {typeof props.selectedSalesOrder !== "undefined"
                  ? props.selectedSalesOrder.seller_name
                  : ""}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              Number of lines :{" "}
              <span style={{ fontSize: "1rem" }}>{props.reviewedSalesOrderItems.length}</span>{" "}
            </Grid>
            <Grid item xs={12}>
              Quantity : <span style={{ fontSize: "1rem" }}>{totalOrderItemCount()} units</span>{" "}
            </Grid>
            <Grid item xs={12}>
              Value : <span style={{ fontSize: "1rem" }}>{computeTotalAmoun()}</span>{" "}
            </Grid>

            <Grid item container>
              <Button
                variant="contained"
                color="primary"
                style={{ width: "100%" }}
                onClick={() => {
                  saveReceivedSalesOrderProducs();
                  // props.closeAllDialog()
                }}
              >
                Finalize Products Received
              </Button>
            </Grid>
          </Grid>
        </div>
      </Dialog>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={materialTheme}>
          {progressDialog()}
          {messageDialog()}
        </ThemeProvider>
      </StyledEngineProvider>
    </div>
  );
}

export default InvoiceInformationReview;
